const Guides = {
  GOOGLE_ENABLE_WEBGL: `
  <h2>Google Chrome 开启 WebGL 方法</h2> <br>
  <pre style="line-height:24px;">
  打开 Google Chrome
  访问这个网址 <a href="chrome://flags">chrome://flags</a>
  按 <strong>Ctrl + f</strong> 并输入 <strong>Override software rendering list</strong>，如果显示 <strong>Disabled</strong> 则把它改为 <strong>Enabled</strong> 并重启浏览器
  到这个网址 <a href="chrome://settings">chrome://settings</a> 并开启 <strong>Use hardware acceleration when available</strong> 最后重启浏览器即可.
  </pre>
  `,
}

export default function Detect() {
  return new Promise((resolve, reject) => {
    if (!DetectWebGL()) reject(new Error(Guides['GOOGLE_ENABLE_WEBGL']))
    resolve()
  })
}

function DetectWebGL() {
  const canvas = document.createElement('canvas')
  const gl =
    canvas.getContext('webgl') || canvas.getContext('experimental-webgl')
  if (gl && gl instanceof WebGLRenderingContext) {
    return true
  } else {
    return false
  }
}
